var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEmptyShareHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 124,
    viewBox: "0 0 120 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1194_23028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 122.009L36.5385 40.3721H82.4038L114 122.009H8Z",
    fill: "url(#paint0_linear_1194_23028)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M33.3366 28.2225C33.2524 16.5003 45.0047 6.94726 59.5371 6.86383C74.0696 6.7804 85.9483 16.2082 85.9904 27.8888L33.3366 28.2225Z",
    fill: "#EABBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2888 27.8894C44.2467 19.8381 51.5761 13.247 60.7167 13.2053C69.8574 13.1636 77.2711 19.6296 77.3132 27.7225L44.2888 27.8894Z",
    fill: "url(#paint1_linear_1194_23028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3365 28.2224L19.1411 33.6455L99.9751 33.1866L86.2851 27.8887L33.3365 28.2224Z",
    fill: "url(#paint2_linear_1194_23028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.184 33.1716L16.7968 33.7009C15.8061 33.707 15.0079 34.515 15.0141 35.5057C15.0202 36.4964 15.8283 37.2946 16.819 37.2885L103.206 36.7592C104.197 36.7531 104.995 35.9451 104.989 34.9544C104.983 33.9637 104.175 33.1655 103.184 33.1716Z",
    fill: "#5D5189"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2245 44.4499C42.2245 44.4499 24.7014 40.7789 20.2364 37.233L46.4368 37.0662L99.4697 36.7324C99.4697 36.7324 88.1386 44.3665 77.5657 44.2413C77.5657 44.2413 77.4394 47.8289 73.3113 47.8289C69.1833 47.8706 46.7738 47.9958 46.7738 47.9958C46.7738 47.9958 41.677 47.1615 41.677 44.3248",
    fill: "url(#paint3_linear_1194_23028)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M61.8115 13.1631C61.8115 13.1631 70.9943 18.7531 67.4139 27.722L75.7963 27.6803C75.7963 27.6803 75.4172 15.6661 61.8115 13.1631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M47.3636 24.4686C47.3214 24.3017 47.2793 24.1348 47.2793 23.968C47.1108 20.9644 50.944 16.2088 54.0611 15.9585C55.2827 15.875 56.757 17.0014 56.0409 18.2946C55.1142 20.0049 53.9348 21.5484 52.7132 23.0502C51.8286 24.1765 50.6913 26.1372 48.9642 25.7618C48.206 25.6366 47.6163 25.1777 47.3636 24.4686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M59.5791 24.1344C59.5791 25.3024 58.6524 26.2619 57.4308 26.2619C56.2514 26.2619 55.2825 25.3441 55.2825 24.1344C55.2825 22.9663 56.2092 22.0068 57.4308 22.0068C58.6102 22.0486 59.5791 22.9663 59.5791 24.1344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5042 34.6629L17.0244 34.7147C16.6558 34.7169 16.3588 35.0176 16.3611 35.3862C16.3634 35.7548 16.6641 36.0518 17.0327 36.0496L25.5125 35.9978C25.8811 35.9956 26.1781 35.6949 26.1758 35.3263C26.1735 34.9577 25.8728 34.6607 25.5042 34.6629Z",
    fill: "url(#paint4_linear_1194_23028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3318 34.663L31.8521 34.7147C31.4834 34.7169 31.1865 35.0176 31.1887 35.3862C31.191 35.7548 31.4917 36.0518 31.8604 36.0496L40.3401 35.9979C40.7087 35.9957 41.0057 35.695 41.0034 35.3264C41.0011 34.9578 40.7004 34.6608 40.3318 34.663Z",
    fill: "url(#paint5_linear_1194_23028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2009 34.663L46.7212 34.7147C46.3526 34.7169 46.0556 35.0176 46.0579 35.3862C46.0602 35.7548 46.3609 36.0518 46.7295 36.0496L55.2092 35.9979C55.5779 35.9957 55.8748 35.695 55.8725 35.3264C55.8703 34.9578 55.5696 34.6608 55.2009 34.663Z",
    fill: "url(#paint6_linear_1194_23028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.029 34.705L61.5492 34.7567C61.1806 34.7589 60.8836 35.0596 60.8859 35.4282C60.8882 35.7968 61.1889 36.0938 61.5575 36.0916L70.0373 36.0399C70.4059 36.0376 70.7029 35.737 70.7006 35.3684C70.6983 34.9997 70.3976 34.7027 70.029 34.705Z",
    fill: "url(#paint7_linear_1194_23028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8987 34.58L76.419 34.6317C76.0503 34.6339 75.7534 34.9346 75.7556 35.3032C75.7579 35.6718 76.0586 35.9688 76.4273 35.9666L84.907 35.9149C85.2756 35.9126 85.5726 35.612 85.5703 35.2434C85.568 34.8747 85.2673 34.5777 84.8987 34.58Z",
    fill: "url(#paint8_linear_1194_23028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7263 34.4549L91.2466 34.5067C90.878 34.5089 90.581 34.8096 90.5833 35.1782C90.5856 35.5468 90.8863 35.8438 91.2549 35.8416L99.7346 35.7899C100.103 35.7876 100.4 35.4869 100.398 35.1183C100.396 34.7497 100.095 34.4527 99.7263 34.4549Z",
    fill: "url(#paint9_linear_1194_23028)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61,
    cy: 120.414,
    rx: 30,
    ry: 4,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 57,
    width: 54,
    height: 54,
    rx: 16,
    fill: "url(#paint10_linear_1194_23028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5 83.75C76.5 87.9272 74.8406 91.9332 71.8869 94.8869C68.9332 97.8406 64.9272 99.5 60.75 99.5C56.5728 99.5 52.5668 97.8406 49.6131 94.8869C46.6594 91.9332 45 87.9272 45 83.75C45 83.4516 45.1185 83.1655 45.3295 82.9545C45.5405 82.7435 45.8266 82.625 46.125 82.625C46.4234 82.625 46.7095 82.7435 46.9205 82.9545C47.1315 83.1655 47.25 83.4516 47.25 83.75C47.2455 86.7628 48.2474 89.6908 50.0968 92.0693C51.9461 94.4477 54.5369 96.1403 57.4579 96.8785C60.3789 97.6166 63.4627 97.3579 66.22 96.1435C68.9772 94.9291 71.2498 92.8285 72.6771 90.1752C74.1044 87.5219 74.6045 84.468 74.0982 81.498C73.5918 78.528 72.108 75.8123 69.8822 73.7818C67.6564 71.7513 64.8162 70.5224 61.8123 70.2902C58.8085 70.058 55.8131 70.8357 53.3017 72.5H54C54.2984 72.5 54.5845 72.6185 54.7955 72.8295C55.0065 73.0405 55.125 73.3266 55.125 73.625C55.125 73.9234 55.0065 74.2095 54.7955 74.4205C54.5845 74.6315 54.2984 74.75 54 74.75H50.625C50.4772 74.7501 50.3309 74.7211 50.1944 74.6645C50.0579 74.608 49.9338 74.5252 49.8293 74.4207C49.7248 74.3162 49.642 74.1922 49.5855 74.0556C49.529 73.9191 49.4999 73.7728 49.5 73.625V70.25C49.5 69.9516 49.6185 69.6655 49.8295 69.4545C50.0405 69.2435 50.3266 69.125 50.625 69.125C50.9234 69.125 51.2095 69.2435 51.4205 69.4545C51.6315 69.6655 51.75 69.9516 51.75 70.25V70.8282C54.1111 69.1825 56.8781 68.2154 59.7503 68.032C62.6225 67.8486 65.4901 68.4559 68.0413 69.7879C70.5926 71.1199 72.73 73.1257 74.2213 75.5872C75.7126 78.0488 76.5007 80.872 76.5 83.75ZM70.875 83.75C70.875 85.7525 70.2812 87.7101 69.1686 89.3752C68.0561 91.0402 66.4748 92.338 64.6247 93.1043C62.7746 93.8706 60.7388 94.0711 58.7747 93.6805C56.8107 93.2898 55.0065 92.3255 53.5905 90.9095C52.1745 89.4935 51.2102 87.6894 50.8195 85.7253C50.4289 83.7612 50.6294 81.7254 51.3957 79.8753C52.1621 78.0252 53.4598 76.4439 55.1249 75.3314C56.7899 74.2188 58.7475 73.625 60.75 73.625C63.4344 73.6279 66.008 74.6956 67.9062 76.5938C69.8044 78.492 70.8721 81.0656 70.875 83.75ZM64.749 85.064L61.875 83.148V78.125C61.875 77.8266 61.7565 77.5405 61.5455 77.3295C61.3345 77.1185 61.0484 77 60.75 77C60.4516 77 60.1655 77.1185 59.9545 77.3295C59.7435 77.5405 59.625 77.8266 59.625 78.125V83.75C59.625 83.9352 59.6708 84.1175 59.7582 84.2808C59.8456 84.4441 59.9719 84.5833 60.126 84.686L63.501 86.936C63.7492 87.0981 64.0514 87.1555 64.3419 87.096C64.6323 87.0364 64.8875 86.8647 65.0519 86.618C65.2164 86.3713 65.2768 86.0697 65.2201 85.7787C65.1634 85.4877 64.9941 85.2309 64.749 85.064Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1194_23028",
    x1: 61,
    y1: 40.3721,
    x2: 61,
    y2: 122.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1194_23028",
    x1: 60.8009,
    y1: 13.2051,
    x2: 60.8009,
    y2: 27.8894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#973BA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF53FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1194_23028",
    x1: 59.5581,
    y1: 27.8887,
    x2: 59.5581,
    y2: 33.6455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAADEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDE8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1194_23028",
    x1: 67.9999,
    y1: 48.2,
    x2: 67.9999,
    y2: 36.2531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAADEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDE8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1194_23028",
    x1: 16.3629,
    y1: 35.6761,
    x2: 26.1776,
    y2: 35.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1194_23028",
    x1: 31.1905,
    y1: 35.6761,
    x2: 41.0052,
    y2: 35.6151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1194_23028",
    x1: 46.0597,
    y1: 35.6761,
    x2: 55.8743,
    y2: 35.6151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1194_23028",
    x1: 60.8877,
    y1: 35.7181,
    x2: 70.7024,
    y2: 35.6571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1194_23028",
    x1: 75.7574,
    y1: 35.5931,
    x2: 85.5721,
    y2: 35.5321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1194_23028",
    x1: 90.5851,
    y1: 35.4681,
    x2: 100.4,
    y2: 35.4071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1194_23028",
    x1: 61,
    y1: 57,
    x2: 61,
    y2: 113.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E600EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9002FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1194_23028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 124,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmptyShareHistory);
export default __webpack_public_path__ + "static/media/icon_empty_share_history.71a8a6fe34e79a4314080827309e569e.svg";
export { ForwardRef as ReactComponent };